import ADD_ATTRIBUTE_TO_PRODUCT from './addAttributeToProduct.graphql'
import ADD_ATTRIBUTE_TO_TYPE from './addAttributeToType.graphql'
import ADD_TYPE_TO_MODEL from './addTypeToModel.graphql'
import ADD_TYPE_TO_PRODUCT    from './addTypeToProduct.graphql'
import DRAFT_MODEL_CONFIG  from './draftModelConfig.graphql'
import EDIT_ATTRIBUTE_FOR_PRODUCT from './editAttributeForProduct.graphql'
import EDIT_ATTRIBUTE_FOR_TYPE from './editAttributeForType.graphql'
import PUBLISH_MODEL_CONFIG from './publishModelConfig.graphql'
import REVERT_MODEL_CONFIG from './revertModelConfig.graphql'
import TAG_TYPES from './tagTypes.graphql'
import TOGGLE_ATTRIBUTE_DELETED_FLAG_FOR_PRODUCT from './toggleAttributeDeletedFlagForProduct.graphql'
import TOGGLE_ATTRIBUTE_DELETED_FLAG_FOR_TYPE from './toggleAttributeDeletedFlagForType.graphql'
import TOGGLE_ATTRIBUTE_REQUIRED_FLAG_FOR_PRODUCT from './toggleAttributeRequiredFlagForProduct.graphql'
import TOGGLE_ATTRIBUTE_REQUIRED_FLAG_FOR_TYPE from './toggleAttributeRequiredFlagForType.graphql'
import TOGGLE_DELETED_FLAG_FOR_TYPE_IN_PRODUCT from './toggleDeletedFlagForTypeInProduct.graphql'
import TOGGLE_DELETED_FLAG_FOR_TYPE from './toggleDeleteFlagForType.graphql'
import UPDATE_TYPE_IN_MODEL from './updateTypeInModel.graphql'
import UPDATE_TYPE_IN_PRODUCT from './updateTypeInProduct.graphql'
import UPDATE_VIEW_FOR_TYPE_IN_MODEL from './updateViewForTypeInModel.graphql'
import PUBLISHED_CONFIG_UPDATED_SUBSCRIPTION from './publishedConfigUpdatedSubscription.graphql'

export {
  ADD_ATTRIBUTE_TO_PRODUCT,
  ADD_ATTRIBUTE_TO_TYPE,
  ADD_TYPE_TO_MODEL,
  ADD_TYPE_TO_PRODUCT,
  DRAFT_MODEL_CONFIG,
  EDIT_ATTRIBUTE_FOR_PRODUCT,
  EDIT_ATTRIBUTE_FOR_TYPE,
  PUBLISH_MODEL_CONFIG,
  REVERT_MODEL_CONFIG,
  TAG_TYPES,
  TOGGLE_ATTRIBUTE_DELETED_FLAG_FOR_PRODUCT,
  TOGGLE_ATTRIBUTE_DELETED_FLAG_FOR_TYPE,
  TOGGLE_ATTRIBUTE_REQUIRED_FLAG_FOR_PRODUCT,
  TOGGLE_ATTRIBUTE_REQUIRED_FLAG_FOR_TYPE,
  TOGGLE_DELETED_FLAG_FOR_TYPE_IN_PRODUCT,
  TOGGLE_DELETED_FLAG_FOR_TYPE,
  UPDATE_TYPE_IN_MODEL,
  UPDATE_TYPE_IN_PRODUCT,
  UPDATE_VIEW_FOR_TYPE_IN_MODEL,
  PUBLISHED_CONFIG_UPDATED_SUBSCRIPTION
}



// WEBPACK FOOTER //
// ./src/modules/common/graphql/configuration/index.ts